import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import {
    AuthorizeGuard,
    FeatureGuard,
    MandatoryPasswordChangeGuard,
    NotAuthorizeGuard,
    PermissionGuard,
} from '@masar/core/guards';

const routes: Routes = [
    {
        path: 'auth',
        canActivateChild: [NotAuthorizeGuard],
        loadChildren: () =>
            import('@masar/layouts/auth-layout/auth-layout.module').then(
                m => m.AuthLayoutModule
            ),
    },

    {
        path: '',
        canActivateChild: [
            AuthorizeGuard,
            MandatoryPasswordChangeGuard,
            PermissionGuard,
            FeatureGuard,
        ],
        loadChildren: () =>
            import('@masar/layouts/default-layout/default-layout.module').then(
                m => m.DefaultLayoutModule
            ),
    },
];

@NgModule({
    imports: [
        RouterModule.forRoot(routes, {
            // Newer Angular versions default to 'always'; keep the Angular 15
            // inheritance of parent params and data.
            paramsInheritanceStrategy: 'emptyOnly',
        }),
    ],
    exports: [RouterModule],
})
export class AppRoutingModule {}
